import { Box, BoxProps, convertHexToRGBA, IconButton, Spacer, Text, TextProps } from '@jfs/ui-new'
import { Dimensions } from 'react-native'
import { Modal } from '../../../../comps/Modal'
import { MerchantTheme } from '../../../../data/models/Config'
import { EmiList } from '../SelectEmiPlans/EmiList'

interface EmiListModelProps {
  show: boolean
  onDismiss: any
  theme: any
  emiPlansData: any
  amountPayable: any
  onPlanSelected: any
}
export const EmiListModel = ({
  show,
  onDismiss,
  theme,
  emiPlansData,
  amountPayable,
  onPlanSelected,
}: EmiListModelProps) => {
  const isLargeScreen = Dimensions.get('window').width > 550
  const isFullScreen =
    window.location.href.includes('/pg/loader.html') || window.location.href.includes('/pg/redirectToBank')
  return (
    <Modal type={'Bottom'} show={show} isFullWidth={true} onDismiss={onDismiss}>
      <Box {...styles.container(isLargeScreen && !isFullScreen, theme)}>
        <Box {...styles.headerContainer}>
          <Box>
            <Text {...styles.headerTitle(theme)}>Choose an EMI Plan</Text>
            <Spacer size={4} />
            <Text {...styles.descTitle(theme)}>{emiPlansData?.bankName}</Text>
          </Box>
          <IconButton
            id={'CLOSE'}
            testID="close-modal"
            onPress={onDismiss}
            color={convertHexToRGBA(theme.bodyTextColor, 40) as any}
          />
        </Box>
        <Box f={1}>
          <EmiList
            theme={theme}
            emiPlansData={emiPlansData}
            amountPayable={amountPayable}
            onPlanSelected={onPlanSelected}
          />
        </Box>
      </Box>
    </Modal>
  )
}

const styles = {
  container: (isLargeScreen: boolean, theme: typeof MerchantTheme.properties) =>
  ({
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    borderBottomLeftRadius: isLargeScreen ? 16 : undefined,
    borderBottomRightRadius: isLargeScreen ? 16 : undefined,
    backgroundColor: theme.bodyBgColor as any,

    height: '60vh',
  } as BoxProps),
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 8,
    p: 24,
  } as BoxProps,
  headerTitle: (theme: typeof MerchantTheme.properties) =>
  ({
    fontSize: 16,
    fontFamily: 'jioType-medium',
    color: theme.bodyTextColor as any,
  } as TextProps),
  descTitle: (theme: typeof MerchantTheme.properties) =>
  ({
    fontSize: 12,
    fontFamily: 'jioType-medium',
    color: convertHexToRGBA(theme.bodyTextColor, 30),
  } as TextProps),
  title: (theme: typeof MerchantTheme.properties) =>
  ({
    fontSize: 14,
    fontFamily: 'jioType-medium',
    color: convertHexToRGBA(theme.bodyTextColor, 50),
    lineHeight: 20,
  } as TextProps),
}
